import { gql } from '@apollo/client';

export const ADD_PATIENT = gql`
  mutation AddPatient($data: CreatePatientInput!) {
    createPatient(data: $data) {
      id
    }
  }
`;
